import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { CouponsSerivce } from '../_services/coupons_service';
import { StorageService } from '../_services/storage.service';
import { ServiceManagment } from '../_services/service_managment';
import { FirebaseService } from '../_services/firebase.service';
import { AlertService } from '../_helpers/alert.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { InsertCouponsDTO } from '../helpers/models/coupons.model';
import { InsertAdminFeeDTO } from '../helpers/models/admin-fee.model';

@Component({
  selector: 'app-admin-fee',
  templateUrl: './admin-fee.component.html',
  styleUrls: ['./admin-fee.component.scss']
})
export class AdminFeeComponent implements OnInit {
  insertAdminDTO: InsertAdminFeeDTO = new InsertAdminFeeDTO();
  pageTitle: string = 'Admin Fees';
  showLoader: boolean = false;

  constructor(
    private couponsManagment: CouponsSerivce,
    private storageService: StorageService,
    private serviceManagment: ServiceManagment,
    private firebase: FirebaseService,
    private alertService: AlertService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private title: Title
  ) { }

  async ngOnInit() {
    await this.getFee();
    // this.setMinDate();
    this.title.setTitle(this.pageTitle);
  }

  async submitForm(form: NgForm) {
    this.showLoader = true;
    if (form.valid) {
      await this.AddComboCoupons();
      this.showLoader = false;
    } else {
      this.showLoader = false;
      this.alertService.show_alert(
        'Please fill all the mandatory fields!',
        '',
        'error'
      );
    }
  }

  async changeDecision(item: any) {
  }

  async AddComboCoupons() {
    this.showLoader = true;
    if (this.insertAdminDTO) {
      // if (!this.insertAdminDTO.isAlwaysValid) {
      //   this.insertAdminDTO.startDate = 0;
      //   this.insertAdminDTO.endDate = 0;
      // }
      // let info = (this.insertAdminDTO.startDate = new Date(
      //   this.insertAdminDTO.startDate
      // ).getTime());
      // this.insertAdminDTO.startDate = info;
      // let infoTwo = (this.insertAdminDTO.endDate = new Date(
      //   this.insertAdminDTO.endDate
      // ).getTime());
      // this.insertAdminDTO.endDate = infoTwo;
      // let infoThree = +this.insertAdminDTO.feeValue;
      // this.insertAdminDTO.feeValue = infoThree;
      await this.couponsManagment.updateFee(this.insertAdminDTO).subscribe({
        next: (response: any) => {
          this.showLoader = false;
          this.alertService.show_alert("Admin Fee Updated Successfully");
          this.router.navigate(['/manage/coupons']);
        },
        error: (errorResponse: any) => {
          this.showLoader = false;
          this.alertService.show_alert('Something went Wrong!', '', 'error');
        },
      });
    } else {
      this.showLoader = false;
      this.alertService.show_alert(
        'Please fill all the mandatory fields!',
        '',
        'error'
      );
    }
    this.showLoader = false;
  }

  setMinDate() {
    let today: any = new Date();
    let dd = today.getDate();
    let mm = today.getMonth() + 1;
    let yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd;
    }

    if (mm < 10) {
      mm = '0' + mm;
    }
    today = yyyy + '-' + mm + '-' + dd;
    let info: any = document.getElementById('endTime');
    let infoTwo: any = document.getElementById('startTime');
    info.setAttribute('min', today);
    infoTwo.setAttribute('min', today);
  }

  async getFee() {
    this.showLoader = true;
    this.couponsManagment.getFee().subscribe({
      next: (response: any) => {
        if (response && response.data) {
          this.insertAdminDTO = response.data;
          // let startDate: any = new Date(this.insertAdminDTO.startDate);
          // let endDate: any = new Date(this.insertAdminDTO.endDate);
          // this.insertAdminDTO.startDate = `${startDate.getFullYear()}-${startDate.getMonth() + 1 > 9
          //   ? startDate.getMonth() + 1
          //   : '0' + (startDate.getMonth() + 1)
          //   }-${startDate.getDate() < 10
          //     ? '0' + startDate.getDate()
          //     : startDate.getDate()
          //   }`;
          // this.insertAdminDTO.endDate = `${endDate.getFullYear()}-${endDate.getMonth() + 1 > 9
          //   ? endDate.getMonth() + 1
          //   : '0' + (endDate.getMonth() + 1)
          //   }-${endDate.getDate() < 10 ? '0' + endDate.getDate() : endDate.getDate()
          //   }`;
          this.showLoader = false;
        } else {
          this.showLoader = false;
        }
      },
      error: (errorResponse: any) => {
        this.showLoader = false;
        this.alertService.show_alert('Something went Wrong!', '', 'error');
      },
    });
  }

}
